<template>
    <div>
        <loading v-show="loading"></loading>

        <div v-show="!loading">
            <tailwind-table v-show="categories.length > 0" :header="['Icon', 'Bookable', 'Edit']">
                <tr v-for="cat in categories">
                    <td class="px-6 py-3">{{ cat.icon }}</td>
                    <td class="px-6 py-3">{{ cat.name }}</td>
                    <td>
                        <bookable-category-single-edit :category="cat" :icons="icons">

                        </bookable-category-single-edit>
                    </td>
                </tr>
            </tailwind-table>

            <p v-show="categories.length === 0">Keine Bookables gefunden.</p>

            <button-secondary class="mt-4" @click="showModal = true">Bookable hinzufügen</button-secondary>
        </div>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Bookable hinzufügen</template>

                <input-text v-model="name" class="mb-4">
                    Name
                    <template v-slot:helper>z.B. Parkplatz, Telefonbox</template>
                </input-text>

                <div class="mb-4">
                    <h2 class=" text-gray-700 font-medium text-sm mb-1">Icon</h2>
                    <ul class="flex">
                        <li v-for="ic in icons" class="inline-block">
                            <a @click="icon = ic" class="block p-4 border rounded-md" :class="{'border-blue-500': ic === icon}">
                                <i class="fa fa-fw" :class="ic"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <select-menu v-model="time_selection_mode" :values="['slot', 'free']"
                             :text="['Eingestellte Slots', 'Freie Zeitwahl']"
                             class="mb-8">
                    Time Selection Mode
                </select-menu>

                <button-primary @click="save">
                    Speichern
                </button-primary>

            </modal>
        </portal>

    </div>
</template>

<script>
import Loading from "../UI/Loading.vue";
import TailwindTable from "../UI/TailwindTable.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import Modal from "../Modal.vue";
import InputText from "../UI/InputText.vue";
import SelectMenu from "../UI/SelectMenu.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import BookableCategorySingleEdit from './BookableCategorySingleEdit.vue';


export default {
    name: "BookableCategoryEdit",

    components: {
        ButtonPrimary,
        SelectMenu,
        InputText,
        Modal,
        ButtonSecondary,
        TailwindTable,
        Loading,
        BookableCategorySingleEdit,

    },

    props: ['group'],

    data: () => ({
        loading: false,
        categories: [],
        showModal: false,
        icons: [],

        name: '',
        icon: 'fa-car',
        time_selection_mode: 'slot',
    }),

    mounted() {
        this.load();
    },

    computed: {
        text() {
            return this.icons.map(item => `<i class="fa ${item}"></i>`);
        },
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/super/bookable_categories', {
                params: {
                    group: this.group.id,
                }
            })
                .then(response => {
                    this.loading = false;
                    this.categories = response.data.data;
                    this.icons = response.data.icons;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        save() {
            this.loading = true;

            this.$http.post('/super/bookable_categories', {
                name: this.name,
                icon: this.icon,
                group: this.group.id,
                time_selection_mode: this.time_selection_mode,
            }).then(result => {
                this.showModal = false;
                this.load();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    },
}
</script>

<style scoped>

</style>
